export default {
  ROOT: '/',
  GAME: {
    ROOT: '/game',
    ACT_1: '/game/act-1',
    ACT_2: '/game/act-2',
    ACT_3: '/game/act-3',
    ACT_4: '/game/act-4',
  },
  TEST: {
    ROOT: '/test',
    ACT_1: '/test/act-1',
    ACT_2: '/test/act-2',
    ACT_3: '/test/act-3',
    ACT_4: '/test/act-4',
  },
};
